export const PROOFS_BUCKET = 'proofs'
